import { HomeFloor0Icon } from './HomeFloor0Icon';

/**
 * author: Michael Irigoyen
 * id 6732D314-97CA-4433-9CB5-260359AC131F
 * name home-floor-0
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-floor-0.svg
 * tags
 * - Home Automation 
 */
export const HouseFloor0Icon = HomeFloor0Icon;
export default HouseFloor0Icon